import React, { useCallback, useEffect, useState } from 'react'
import { getStatus } from '../../../helperFunction/status';

function TaskStatus({ taskData }) {

    const [refundedAmount, setRefundedAmount] = useState(false);
    const [curruntStatus, setCurruntStatus] = useState();
    const [classState, setClassState] = useState('live');


    function endingSoon() {
        let endTime = new Date(taskData?.endTime);
        let currentTime = new Date();
        let timeDifference = endTime - currentTime;
        return timeDifference
    }

    useEffect(() => {
        if (taskData) {
            if (taskData?.status === 'completed') {
                taskData.isClaimed = true
            } else {
                taskData.isClaimed = false
            }

            let status = getStatus(taskData, 'taskDetail');
            setCurruntStatus(status);
            if (status === 'live') {
                let timeDifference = endingSoon()
                // Check if endTime is within the next 24 hours
                if (timeDifference < 24 * 60 * 60 * 1000) {
                    setClassState('ending');
                } else {
                    setClassState('live');
                }

            } else if (status === 'underReview') {
                setClassState('review')
            } else if (status === 'inDisputePeriod') {
                setClassState('dispute')
            } else if (status === 'inVotingPeriod') {
                setClassState('inVoting')
            } else if (status === 'winnerSelected' && !taskData?.winnerSelected) {
                setClassState('ended')
            } else if (status === 'winnerSelected') {
                setClassState('winnerSelected')
            }
            // else if (status === 'completed') {
            //     setClassState('completed')
            // } 
            else if (status === 'Ended' || status === 'completed') {
                setClassState('ended')
            }
            // console.log(status, 'statusstatusstatus');
        }
    }, [taskData, refundedAmount]);

    function formatStatus(status) {
        status = status === 'winnerSelected' && !taskData?.winnerSelected ? 'Ended' : status
        let timeDifference = endingSoon();
        let newStatus = status === 'completed' ? 'ended' : status === 'live' ? (timeDifference < 24 * 60 * 60 * 1000 ? 'Ending Soon' : status) : status;
        // Separate camelCase words and capitalize the first letter of each word
        const formatted = newStatus?.replace(/([a-z])([A-Z])/g, '$1 $2')  // Adds space between camelCase words
            .split(' ')  // Split into words
            .map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))  // Capitalize first letter
            .join(' ');  // Join the words back together

        return formatted;
    }

    console.log(curruntStatus, "curruntStatusokokokokok", formatStatus(curruntStatus));

    return (
        <>
            <div className={`single-elem ${classState}`}>
                <h6> {formatStatus(curruntStatus)}</h6>
            </div>
        </>
    )
}

export default TaskStatus